var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Ai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 2.83348C12.3724 2.83349 12.7388 2.85781 13.0991 2.90086C13.6005 7.08275 16.9159 10.3957 21.0981 10.896C21.1416 11.2581 21.1665 11.6267 21.1665 12.0005C21.1665 12.3717 21.142 12.7375 21.0991 13.0972C16.9147 13.5972 13.5974 16.9134 13.0981 21.0981C12.7381 21.1411 12.3721 21.1665 12.0005 21.1665C11.628 21.1665 11.2608 21.1413 10.8999 21.0981C10.4005 16.9133 7.08468 13.5969 2.8999 13.0972C2.85701 12.7375 2.83351 12.3717 2.8335 12.0005C2.8335 11.6267 2.85741 11.258 2.90088 10.896C7.08345 10.3961 10.3974 7.08295 10.8989 2.90086C11.26 2.85762 11.6277 2.83348 12.0005 2.83348Z",
    fill: "#0089FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Ai);
export default __webpack_public_path__ + "static/media/24_AI.a5c76c3467687ff850682dd7b62d64a5.svg";
export { ForwardRef as ReactComponent };